import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function UrgencyBar() {
  // Start with 45 minutes and 12 seconds (2712 seconds)
  const [timeLeft, setTimeLeft] = useState(45 * 60 + 12);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timerId = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timerId);
  }, [timeLeft]);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    if (h > 0) {
      return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
    }
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <div className="sticky top-0 z-50 bg-brand-red text-white py-2 px-4 shadow-md" data-id="element-254">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-sm sm:text-base font-medium text-center" data-id="element-255">
        <div className="flex items-center gap-2" data-id="element-256">
          <Clock className="w-4 h-4 animate-pulse" data-id="element-257" />
          <span data-id="element-258">
            ¡OFERTA DE LANZAMIENTO! El precio de $37 expira cuando el contador
            llegue a cero.
          </span>
        </div>
        <div className="font-bold font-mono bg-black/20 px-3 py-1 rounded-md tracking-wider" data-id="element-259">
          [{formatTime(timeLeft)}]
        </div>
      </div>
    </div>;
}